export const marketsArray = [
    {
        id: '7',
        symbol: 'WAL',
        coinType: '0x356a26eb9e012a68958082340d4c4116e7f55615cf27affcff209cf0ae544f59::wal::WAL',
        expo: 9,
    },
    {
        id: '11',
        symbol: 'DEEP',
        coinType: '0xdeeb7a4662eec9f2f3def03fb937a663dddaa2e215b8078a284d026b7946c270::deep::DEEP',
        expo: 6,
    },
    {
        id: '2',
        symbol: 'stSUI',
        coinType: '0xd1b72982e40348d069bb1ff701e634c117bb5f741f44dff91e472d3b01461e55::stsui::STSUI',
        expo: 9,
    },
    {
        id: '1',
        symbol: 'SUI',
        coinType: '0x2::sui::SUI',
        expo: 9,
    },
    {
        id: '6',
        symbol: 'USDC',
        coinType: '0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC',
        expo: 6,
        okxUrl: 'https://web3.okx.com/earn/product/bluefin-sui-usdc-33602#source=activitypage&activitySourcePage=sui',
    },
    {
        id: '5',
        symbol: 'suiUSDT',
        coinType: '0x375f70cf2ae4c00bf37117d0c85a2c71545e6ee05c4a5c7d282cd66a4504b068::usdt::USDT',
        expo: 6,
    },
    {
        id: '18',
        symbol: 'XAUm',
        coinType: '0x9d297676e7a4b771ab023291377b2adfaa4938fb9080b8d12430e4b108b836a9::xaum::XAUM',
        expo: 9,
    },
    {
        id: '3',
        symbol: 'wBTC',
        coinType: '0xaafb102dd0902f5055cadecd687fb5b71ca82ef0e0285d90afde828ec58ca96b::btc::BTC',
        expo: 8,
    },
    {
        id: '14',
        symbol: 'tBTC',
        coinType: '0x77045f1b9f811a7a8fb9ebd085b5b0c55c5cb0d1520ff55f7037f89b5da9f5f1::TBTC::TBTC',
        expo: 8,
    },
    {
        id: '16',
        symbol: 'xBTC',
        coinType: '0x876a4b7bce8aeaef60464c11f4026903e9afacab79b9b142686158aa86560b50::xbtc::XBTC',
        expo: 8,
        okxUrl: 'https://web3.okx.com/earn/product/bluefin-sui-xbtc-33513#source=activitypage&activitySourcePage=sui',
    },
    {
        id: '4',
        symbol: 'LBTC',
        coinType: '0x3e8e9423d80e1774a7ca128fccd8bf5f1f7753be658c5e645929037f7c819040::lbtc::LBTC',
        expo: 8,
    },
    {
        id: '15',
        symbol: 'IKA',
        coinType: '0x7262fb2f7a3a14c888c438a3cd9b912469a58cf60f367352c46584262e8299aa::ika::IKA',
        expo: 9,
    },
    {
        id: '10',
        symbol: 'suiETH',
        coinType: '0xd0e89b2af5e4910726fbcd8b8dd37bb79b29e5f83f7491bca830e94f7f226d29::eth::ETH',
        expo: 8,
    },
    {
        id: '9',
        symbol: 'BLUE',
        coinType: '0xe1b45a0e641b9955a20aa0ad1c1f4ad86aad8afb07296d4085e349a50e90bdca::blue::BLUE',
        expo: 9,
    },
    {
        id: '21',
        symbol: 'eSUI',
        coinType: '0x66629328922d609cf15af779719e248ae0e63fe0b9d9739623f763b33a9c97da::esui::ESUI',
        expo: 9,
    },
    {
        id: '26',
        symbol: 'eWAL',
        coinType: '0x8a398f65f8635be31c181632bf730aea25074505d70c77d9b287e7d4f063ef70::ewal::EWAL',
        expo: 9,
    },
    {
        id: '23',
        symbol: 'eTHIRD',
        coinType: '0x89b0d4407f17cc1b1294464f28e176e29816a40612f7a553313ea0a797a5f803::ethird::ETHIRD',
        expo: 6,
    },
    {
        id: '24',
        symbol: 'exBTC',
        coinType: '0x56589f5381303a763a62e79ac118e5242f83652f4c5a9448af75162d8cb7140c::exbtc::EXBTC',
        expo: 8,
    },
    {
        id: '22',
        symbol: 'egUSDC',
        coinType: '0x68532559a19101b58757012207d82328e75fde7a696d20a59e8307c1a7f42ad7::egusdc::EGUSDC',
        expo: 6,
    },
    {
        id: '20',
        symbol: 'eBTC',
        coinType: '0x244b98d29bd0bba401c7cfdd89f017c51759dad615e15a872ddfe45af079bb1d::ebtc::EBTC',
        expo: 8,
    },
    {
        id: '13',
        symbol: 'DMC',
        coinType: '0x4c981f3ff786cdb9e514da897ab8a953647dae2ace9679e8358eec1e3e8871ac::dmc::DMC',
        expo: 9,
    },
    {
        id: '12',
        symbol: 'ALPHA',
        coinType: '0xfe3afec26c59e874f3c1d60b8203cb3852d2bb2aa415df9548b8d688e6683f93::alpha::ALPHA',
        expo: 9,
    },
    {
        id: '17',
        symbol: 'ALKIMI',
        coinType: '0x1a8f4bc33f8ef7fbc851f156857aa65d397a6a6fd27a7ac2ca717b51f2fd9489::alkimi::ALKIMI',
        expo: 9,
    },
    {
        id: '19',
        symbol: 'UP',
        coinType: '0x87dfe1248a1dc4ce473bd9cb2937d66cdc6c30fee63f3fe0dbb55c7a09d35dec::up::UP',
        expo: 6,
    },
];
export const oraclePriceOverrides = {
    suiUSDT: 'USDT',
    suiETH: 'ETH',
    wBTC: 'BTC',
    LBTC: 'BTC',
    tBTC: 'BTC',
    xBTC: 'BTC',
    eSUI: 'SUI',
    eBTC: 'BTC',
    egUSDC: 'USDC',
    eTHIRD: 'USDC',
    exBTC: 'BTC',
    eWAL: 'WAL',
    ALPHA: null, // No oracle price feed
};
export const getOraclePriceLink = (tokenSymbol) => {
    const overrideValue = oraclePriceOverrides[tokenSymbol];
    const tokenForOracle = overrideValue !== null && overrideValue !== void 0 ? overrideValue : (overrideValue === null ? null : tokenSymbol.toUpperCase());
    if (!tokenForOracle) {
        return undefined;
    }
    return `https://insights.pyth.network/price-feeds/Crypto.${tokenForOracle}%2FUSD${tokenForOracle === 'XAUM' ? '.RR' : ''}`;
};
